import type React from 'react'

/** Shared field styles; variants: 'underline' (work ticket), 'boxed' (cancel). */
export const fieldStyles = {
  item: {
    padding: '14px 0',
    borderBottom: '1px solid rgba(0,0,0,0.08)',
  } as React.CSSProperties,
  label: {
    display: 'block',
    fontSize: '14px',
    fontWeight: 700,
    color: 'var(--cs-color-text, #1a1a1a)',
    marginBottom: '8px',
    letterSpacing: '0.01em',
  } as React.CSSProperties,
  errorText: {
    color: 'var(--ion-color-danger, #eb445a)',
    fontSize: '12px',
    fontWeight: 600,
    marginTop: '4px',
    display: 'block',
  } as React.CSSProperties,
  buttonReset: {
    border: 'none',
    background: 'none',
    padding: 0,
    margin: 0,
    font: 'inherit',
    color: 'inherit',
    cursor: 'pointer',
    textAlign: 'left' as const,
    width: '100%',
    WebkitAppearance: 'none' as const,
    appearance: 'none' as const,
  } as React.CSSProperties,
}

const inputBase: React.CSSProperties = {
  width: '100%',
  fontSize: '16px',
  fontFamily: 'inherit',
  fontWeight: 400,
  outline: 'none',
  WebkitAppearance: 'none' as const,
  appearance: 'none' as const,
}

export const inputVariants = {
  underline: {
    base: {
      ...inputBase,
      padding: '6px 0',
      border: 'none',
      borderRadius: '0',
      backgroundColor: 'transparent',
      color: 'var(--ion-text-color, #303030)',
    } as React.CSSProperties,
    focus: {
      borderBottom: '2px solid var(--ion-color-primary)',
    } as React.CSSProperties,
  },
  boxed: {
    base: {
      ...inputBase,
      padding: '14px 16px',
      border: '1.5px solid rgba(0,0,0,0.1)',
      borderRadius: '5px',
      backgroundColor: 'var(--cs-color-surface, #fafafa)',
      color: 'var(--cs-color-text, #1a1a1a)',
      transition: 'border-color 0.2s, box-shadow 0.2s',
    } as React.CSSProperties,
    focus: {
      borderColor: 'var(--ion-color-primary, #3880ff)',
      boxShadow: '0 0 0 3px rgba(56,128,255,0.12)',
      backgroundColor: 'var(--cs-color-surface, #fff)',
    } as React.CSSProperties,
  },
}

export const textareaVariants = {
  underline: {
    base: {
      ...inputVariants.underline.base,
      resize: 'vertical' as const,
      minHeight: '60px',
    } as React.CSSProperties,
    focus: inputVariants.underline.focus,
  },
  boxed: {
    base: {
      ...inputVariants.boxed.base,
      resize: 'vertical' as const,
      minHeight: '90px',
    } as React.CSSProperties,
    focus: inputVariants.boxed.focus,
  },
}

export type FieldVariant = keyof typeof inputVariants
